import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { LoadingState, deepCopy, srSpeak, SnackbarService, SnackbarType } from 'src/app/shared';
import { SubSink } from 'subsink';
import {
  ConfigurationService,
  DisplayService,
  Excel,
  ExportRequest,
  TranslationService,
} from '../..';
import { DelegationService } from '../../services/delegation.service';
import { InpageAliasService } from '../../services/inpage-alias.service';
import { Session } from '../../services/session.service';
import {
  DetailSearchConfiguration,
  SearchRequest,
} from '../search/detail-search-form.component';
import { Delegatee, Delegator } from './act-delegate-page.component';
import { ListComponent } from '../../../shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { Aliases } from '../../models/aliases';
/* import { customvalidations } from 'src/app/shared/models/customvalidations.validator';
import { start } from 'repl';
import { endOfDay } from 'date-fns';
 */
@Component({
  selector: 'app-manage-delegate-page',
  template: `
    <app-section class="tw-w-full">
      <app-claim-breadcrumb class="tw-w-[90%]"></app-claim-breadcrumb>

      <form
        [formGroup]="delegateFormGroup"
        class="tw-w-full tw-flex tw-flex-wrap tw-items-center tw-px-2 tw-pb-1"
      >
        <div class="tw-w-full md:tw-w-[30%]">
          <app-manager-selector
            *ngIf="filterByDelegator"
            [isDelegatorSearch]="true"
            formControlName="delegator"
            [formGroup]="delegateFormGroup"
            label="Filter by delegator"
            ngDefaultControl
            [managerLookupSupervisor]="true"
            [managerLookupOmni]="false"
          >
          </app-manager-selector>
        </div>
      </form>

      <div
        *ngIf="!delegationFeatures?.manageOwnDelegates && !filteringByDelegator"
        class="tw-flex tw-items-center tw-w-full tw-h-full tw-justify-around tw-py-8"
      >
        <app-empty-state-label
          icon="group_off"
          header="Managing own delegates has not been enabled for your role"
          message="Please contact your administrator for access"
        >
        </app-empty-state-label>
      </div>

      <app-panel
        *ngIf="showPanels"
        [headerLevel]="1"
        [canExpand]="false"
        [expanded]="true"
        [title]="
          (viewDelegatorLabel
            ? (viewDelegatorLabel | sentenceCase) + ' - '
            : '') + ('Manage delegates' | translation: translationRequest)
        "
        class="tw-w-full"
        [sentenceCase]="false"
      >
        <app-loading-panel [skeletonLines]="8" [state]="loading">
          <ng-template #empty>
            <div
              class="tw-flex tw-items-center tw-w-full tw-h-full tw-justify-around"
            >
              <app-empty-state-label
                icon="group_off"
                header="There are currently no delegates assigned"
                message="Use the form below to add delegates"
              >
              </app-empty-state-label>
            </div>
          </ng-template>
          <ng-template #content>
            <app-list
              class="tw-w-full"
              [dataSource]="delegateService.currentDelegatees()"
              [template]="row"
              [filterEnabled]="true"
              [exportEnabled]="true"
              exportButtonAriaLabel="Export and download these delegates as a XLSX file"
              [noDataIcon]="noDataIcon"
              [tableAriaLabel]="'Manage Added Delagates'"
              noDataHeader="No results"
              noDataMessage="There are no results that match the search"
              (export)="_export()"
            >
              <ng-container header>
                <tr class="tw-flex tw-flex-wrap">
                  <app-list-header
                    name="delegateeLabel"
                    label="Delegate"
                    class="tw-w-[20%]"
                  ></app-list-header>
                  <app-list-header
                    name="dateEffective"
                    label="Delegation start date"
                    class="tw-w-[20%]"
                  ></app-list-header>
                  <app-list-header
                    name="dateExpire"
                    label="Delegation end date"
                    class="tw-w-[20%]"
                  ></app-list-header>
                  <app-list-header
                    name="edit"
                    label="Edit"
                    [sortEnabled]="false"
                    class="tw-w-[20%]"
                  ></app-list-header>
                  <app-list-header
                    name="remove"
                    label="Remove"
                    class="tw-w-[20%]"
                    [sortEnabled]="false"
                  ></app-list-header>
                </tr>
              </ng-container>
              <ng-template #row let-element>
                <tr class="tw-flex tw-flex-wrap tw-items-center">
                  <td class="tw-w-full sm:tw-w-[20%] hylinks">
                    <app-value
                      [value]="element.delegateeLabel | titlecase"
                      label="Delegatee"
                      [attr.tabindex]="element.delegateeLabel ? '0' : '-1'"
                      layout="row-xs"
                      [translationNeeded]="false"
                    ></app-value>
                  </td>
                  <td class="tw-w-full sm:tw-w-[20%]">
                    <app-value
                      label="Delegation Start Date"
                      [tabindex]="element.dateEffective ? '0' : '-1'"
                      layout="row-xs"
                      [value]="element.dateEffective | format: 'date'"
                      [translationNeeded]="false"
                    >
                    </app-value>
                  </td>
                  <td class="tw-w-full sm:tw-w-[20%]">
                    <div class="tw-flex tw-items-center tw-flex-nowrap">
                      <app-value
                        label="Delegation End Date"
                        [tabindex]="element.dateExpire ? '0' : '-1'"
                        layout="row-xs"
                        [value]="element.dateExpire | format: 'date'"
                        [translationNeeded]="false"
                      >
                      </app-value>
                      @if (element.expiringSoon) {
                        <span
                          class="app-indicator-expiring tw-ml-1 tw-whitespace-nowrap"
                          >{{ 'Expiring Soon' | translation: translationRequest }}</span
                        >
                      }
                    </div>
                  </td>
                  <td class="tw-w-full sm:tw-w-[20%]">
                    <div>
                      <app-icon-button
                        [attr.aria-label]="
                          'Edit delegate ' + element.delegateeLabel
                        "
                        icon="edit"
                        label="Edit"
                        tabindex="0"
                        role="button"
                        (click)="
                          editLabel = 'Edit delegate';
                          current = element;
                          setCurrentValues()
                        "
                        (keydown.enter)="
                          editLabel = 'Edit delegate';
                          current = element;
                          setCurrentValues()
                        "
                      ></app-icon-button>
                    </div>
                  </td>
                  <td class="tw-w-full sm:tw-w-[20%]">
                    <div>
                      <app-icon-button
                        [attr.aria-label]="
                          'Remove delegate ' + element.delegateeLabel
                        "
                        tabindex="0"
                        role="button"
                        icon="delete_forever"
                        label="Remove"
                        (click)="current = element; dialog.open(removeDialog)"
                        (keydown.enter)="
                          current = element; dialog.open(removeDialog)
                        "
                      ></app-icon-button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </app-list>
          </ng-template>
        </app-loading-panel>
      </app-panel>
      <ng-template #removeDialog let-element="element">
        <app-dialog-container
          [headerId]="'removeDelegate'"
          [headerLevel]="2"
          aria-labelledby="'removeDelegate'"
        >
          <div class="tw-py-6">
            {{
              'Press the confirm button below to remove Delegate'
                | translation: translationRequest
            }}
            <b>{{ current.delegateeLabel }}</b>
          </div>
          <app-action-row>
            <app-button
              emphasis="High"
              right2
              matDialogClose
              (click)="removeDelegate()"
              label="Confirm"
            ></app-button>
            <app-button
              emphasis="Low"
              right1
              matDialogClose
              label="Cancel"
            ></app-button>
          </app-action-row>
        </app-dialog-container>
      </ng-template>

      <ng-template #editDialog>
        <app-dialog-container
          [label]="editLabel"
          [headerId]="'editDelegate'"
          [headerLevel]="2"
          (clearClicked)="resetFormGroup()"
          aria-labelledby="'editDelegate'"
        >
          <form
            class="tw-max-w-md tw-flex tw-flex-wrap"
            [formGroup]="formGroup"
          >
            <div class="tw-w-full tw-pb-4 tw-pt-2 tw-text-lg">
              {{ current.delegateeLabel }}
            </div>
            <div class="tw-w-full tw-pb-4 tw-pt-2 tw-text-md" tabindex="0">
              {{
                'Asterisks(*) indicate required fields.'
                  | translation: translationRequest
              }}
            </div>
            <app-date-control
              formControlName="startDate"
              [formGroup]="formGroup"
              label="Start Date"
              ngDefaultControl
              [validationControl]="'Start Date'"
              class="tw-w-full md:tw-w-[50%]"
            ></app-date-control>
            <app-date-control
              formControlName="endDate"
              [formGroup]="formGroup"
              label="End Date"
              ngDefaultControl
              [validationControl]="'End Date'"
              class="tw-w-full md:tw-w-[50%]"
            ></app-date-control>
            <h3 class="tw-w-full tw-pb-4 tw-pt-4 app-label">
              {{ 'Permissions' | translation: translationRequest }}
            </h3>
            <div class="tw-w-full">
              <app-toggle-control
                formControlName="reportAbsence"
                [formGroup]="formGroup"
                ngDefaultControl
                label="Report an absence"
                labelClass="tw-font-bold app-color-slate"
              ></app-toggle-control>
            </div>
            <div class="tw-w-full">
              <app-toggle-control
                formControlName="reportClaim"
                [formGroup]="formGroup"
                ngDefaultControl
                [label]="
                  reportClaimLabel | aliasTransform: 'none' : translationRequest
                "
                labelClass="tw-font-bold app-color-slate"
              ></app-toggle-control>
            </div>
            <div class="tw-w-full">
              <app-toggle-control
                formControlName="receiveEmail"
                [formGroup]="formGroup"
                ngDefaultControl
                label="Receive email correspondence for claim"
                labelClass="tw-font-bold app-color-slate"
              ></app-toggle-control>
            </div>

            <div class="tw-w-full tw-pb-4">
              <app-toast
                type="Error"
                *ngIf="noChangesMade"
                [message]="
                  'Error : Please enter at least one update criteria or cancel to close the window.'
                "
              >
              </app-toast>
            </div>
            <app-toast
              type="Error"
              *ngIf="formGroup.controls.receiveEmail.disabled"
              [message]="
                'Email permissions can\\'t be set for this delegatee because email information is missing for delegatee/delegator.'
              "
            >
            </app-toast>
            <app-action-row class="tw-w-full">
              <app-button
                emphasis="High"
                role="button"
                right2
                (click)="addDelegate()"
                label="Save"
              ></app-button>
              <app-button
                emphasis="Low"
                role="button"
                right1
                matDialogClose
                (click)="resetFormGroup()"
                label="Cancel"
              ></app-button>
            </app-action-row>
          </form>
        </app-dialog-container>
      </ng-template>
      <app-panel
        *ngIf="showPanels"
        title="Add a delegate"
        [headerLevel]="2"
        class="tw-w-full"
      >
        <app-toast
          type="Info"
          *ngIf="hasActAsDelegateRestrictions"
          [message]="delegationRolesMessage"
        >
        </app-toast>
        <div class="tw-min-h-[510px] tw-w-full">
          <app-detail-search-form
            #searchForm
            [config]="config"
            (search)="searchDelegatees($event)"
            [loading]="searchLoading"
            [translationRequest]="translationRequest"
          >
          </app-detail-search-form>
          <app-loading-panel [skeletonLines]="8" [state]="searchLoading">
            <ng-template #empty>
              <div
                class="tw-flex tw-items-center tw-w-full tw-h-full tw-justify-around"
              >
                <app-empty-state-label
                  icon="search"
                  x-header="Search results"
                  [message]="config.initialSearchMsg"
                >
                </app-empty-state-label>
              </div>
            </ng-template>
            <ng-template #content>
              <app-search-count-row
                [count]="searchResults.length"
                [maxResultsMsg]="maxResultsMsg"
                [resultSingle]="employeeAlias?.value"
                [resultPlural]="employeeAlias?.value + 's'"
              ></app-search-count-row>
              <app-list
                class="tw-w-full"
                [dataSource]="searchResults"
                [template]="addRow"
                [filterEnabled]="true"
                [exportEnabled]="true"
                exportButtonAriaLabel="Export and download these delegates as a XLSX file"
                [noDataIcon]="noDataIcon"
                noDataHeader="No Results"
                noDataMessage="There are no results that match the search"
                (export)="_results_export()"
                [tableAriaLabel]="'Search Delegatee Results'"
                #searchResultList
              >
                <ng-container header>
                  <tr class="tw-flex tw-flex-wrap">
                    <app-list-header
                      name="add"
                      label="Action"
                      class="tw-w-[33%]"
                      [sortEnabled]="false"
                    ></app-list-header>
                    <app-list-header
                      name="delegateeLabel"
                      label="Name"
                      class="tw-w-[33%]"
                    ></app-list-header>
                    <app-list-header
                      name="managerLabel"
                      label="Manager"
                      class="tw-w-[34%]"
                    ></app-list-header>
                  </tr>
                </ng-container>
                <ng-template #addRow let-element>
                  <tr class="tw-flex tw-flex-wrap tw-w-full tw-items-center">
                    <td class="tw-w-full sm:tw-w-[33%]">
                      <app-icon-button
                        *ngIf="!element.isExistingDelegatee"
                        icon="group_add"
                        label="Add delegate | translation: translationRequest"
                        role="button"
                        tabindex="0"
                        [attr.aria-label]="'Add Delegate'"
                        (click)="
                          editLabel = 'Add delegate';
                          current = element;
                          resetFormGroup();
                          setCurrentValues(true)
                        "
                        (keydown.enter)="
                          editLabel = 'Add delegate';
                          current = element;
                          resetFormGroup();
                          setCurrentValues(true)
                        "
                      ></app-icon-button>
                      <app-icon-button
                        *ngIf="element.isExistingDelegatee"
                        [attr.aria-label]="
                          ('Edit delegate' | translation: translationRequest) +
                          ' ' +
                          element.delegateeLabel
                        "
                        icon="edit"
                        label="Edit"
                        tabindex="0"
                        role="button"
                        (click)="
                          editLabel = 'Edit delegate';
                          current = element;
                          setCurrentValues()
                        "
                        (keydown.enter)="
                          editLabel = 'Edit delegate';
                          current = element;
                          setCurrentValues()
                        "
                      ></app-icon-button>
                    </td>
                    <td class="tw-w-full sm:tw-w-[33%]">
                      <app-value
                        [value]="element.delegateeLabel"
                        [tabindex]="element.delegateeLabel ? '0' : '-1'"
                        layout="row-xs"
                        [translationNeeded]="false"
                      >
                      </app-value>
                    </td>
                    <td class="tw-w-full sm:tw-w-[34%]">
                      <app-value
                        layout="row-xs"
                        [value]="element.managerLabel"
                        [tabindex]="element.managerLabel ? '0' : '-1'"
                        [translationNeeded]="false"
                      >
                      </app-value>
                    </td>
                  </tr>
                </ng-template>
              </app-list>
            </ng-template>
          </app-loading-panel>
        </div>
      </app-panel>
    </app-section>
  `,
  styles: `
    .hylinks {
      font-weight: 400 !important;
      text-decoration: none !important;
      cursor: default;
    }
    .hylinks:focus {
      outline-style: solid !important;
      outline-width: 2px !important;
      outline-color: #007dbb !important;
    }
  `,
  standalone: false,
})
export class ManageDelegatePageComponent implements OnInit {
  subs = new SubSink();

  @Output()
  export = new EventEmitter<ExportRequest>();

  get startControl() {
    return this.formGroup.controls.startDate;
  }

  get endControl() {
    return this.formGroup.controls.endDate;
  }

  get startDate() {
    return this.dateonly(new Date(this.formGroup.controls.startDate.value));
  }
  get endDate() {
    return this.dateonly(new Date(this.formGroup.controls.endDate.value));
  }

  config = new DetailSearchConfiguration();
  employeeAlias: Aliases;
  current: Delegatee;
  dialogRef: MatDialogRef<any>;
  searchResults: any[];
  maxResultsMsg: string =
    'The Search Results maximum has been exceeded. Please modify the search and try again.';
  isMaxCount: boolean = false;
  searchRequest: SearchRequest;
  loading: LoadingState;
  searchLoading: LoadingState = 'Init';
  noDataIcon: string = 'list_alt';
  viewDelegatorLabel: string = '';
  filterByDelegator: boolean = false;
  filteringByDelegator: boolean = false;
  filteredDelegator: Delegator;
  noChangesMade: boolean = false;
  validatingDates: boolean = false;
  reportClaimLabel: Aliases = {
    value: 'Report a new claim',
    key: 'ReportClaim',
    isOverride: false,
  } as Aliases;
  delegationFeatures: any;
  showPanels = false;
  delegationRolesMessage =
    'Your employer has restricted delegation to specific roles. While you may be able to add any employee, not all employees can serve as delegates.';
  employerLabel: Aliases = {
    value: 'employer',
    key: 'employerSingular',
    isOverride: false,
  } as Aliases;
  employeeLabelSingular: Aliases = {
    value: 'employee',
    key: 'employeeSingular',
    isOverride: false,
  } as Aliases;
  employeeLabelPlural: Aliases = {
    value: 'employees',
    key: 'employeePlural',
    isOverride: false,
  } as Aliases;
  hasActAsDelegateRestrictions = false;

  @ViewChild('editDialog', { static: true }) editDialog: TemplateRef<any>;
  @ViewChild('searchResultList', { static: false })
  searchResultList: ListComponent;

  formGroup = this.fb.group({
    startDate: [''],
    endDate: [''],
    reportAbsence: [false],
    reportClaim: [false],
    receiveEmail: [false],
  });

  delegateFormGroup = this.fb.group({
    delegator: [],
  });

  editLabel = 'Edit delegate';

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Managedelegatepage',
    subGroup: 'Managedelegatepage',
  });

  constructor(
    public dialog: MatDialog,
    private fb: FormBuilder,
    public delegateService: DelegationService,
    private session: Session,
    private aliases: InpageAliasService,
    public cdr: ChangeDetectorRef,
    public display: DisplayService,
    private excel: Excel,
    private claimConfigService: ConfigurationService,
    public inpageAliasService: InpageAliasService,
    private translationService: TranslationService,
    private snackbar: SnackbarService,
  ) {
    this.config.key = 'manage-delegates:search-employees';
    this.config.setVisibility(true);
    this.config.firstName.visible = true;
    this.config.lastName.visible = true;
    this.config.employeeId.visible = true;
    this.config.initialSearch = false;
    this.config.initialSearchResultsOnClear = false;
    this.config.managerLookupSupervisor = false;
    this.config.showParametersToggle = false;
    this.config.expanded = true;
    this.config.claimNumber.visible = false;
    this.config.lob.visible = false;
    this.config.includeIndirect.visible = false;
    this.config.supervisor.visible = false;
    this.config.endDate.visible = false;
    this.config.startDate.visible = false;
    this.config.ssn.visible = false;
    this.config.status.visible = false;
    this.config.firstName.widthPercent = 33;
    this.config.lastName.widthPercent = 33;
    this.config.employeeId.widthPercent = 33;
    this.config.emptyFormAllowed = false;
    this.config.payType.visible = false;
    this.config.initialSearchMsg = 'Search results will appear here.';
    this.config.setDefaultVisibilitySettings = false;
    this.config.alertType.visible = false;
  }

  loadTranslations(): void {
    this.translationService.getTranslation(this.translationRequest);
  }

  async ngOnInit() {
    this.loadTranslations();
    if (this.claimConfigService.GetConfig.configFeatures) {
      this.employerLabel = await this.inpageAliasService.replaceAliases(
        'employerSingular',
        this.claimConfigService.GetConfig.configFeatures.aliases,
      );
      this.employeeLabelSingular = await this.inpageAliasService.replaceAliases(
        'employeeSingular',
        this.claimConfigService.GetConfig.configFeatures.aliases,
      );
      this.employeeLabelPlural = await this.inpageAliasService.replaceAliases(
        'employeePlural',
        this.claimConfigService.GetConfig.configFeatures.aliases,
      );
      this.delegationRolesMessage = this.inpageAliasService.composeSentence([
        'Your employer has restricted delegation to specific roles. While you may be able to add any',
        { alias: this.employeeLabelSingular },
        'not all',
        { alias: this.employeeLabelPlural },
        'can serve as delegates.',
      ]);
    }
    this.delegationFeatures = await this.display.delegationFeatures();
    this.showPanels =
      this.delegationFeatures?.manageOwnDelegates || this.filteringByDelegator;
    this.hasActAsDelegateRestrictions =
      await this.delegateService.checkActAsDelegateRestrictions(
        this.session.user.contNum,
      );
    this.subs.sink = this.startControl.valueChanges.subscribe((v) => {
      if (v && this.current !== undefined && this.current !== null) {
        this.validateInputs();
        this.validateDates();
      }
    });

    this.subs.sink = this.endControl.valueChanges.subscribe((v) => {
      if (v && this.current !== undefined && this.current !== null) {
        this.validateInputs();
        this.validateDates();
      }
    });

    this.reportClaimLabel = await this.aliases.replaceAliases(
      'ReportClaim',
      this.claimConfigService.GetConfig.configFeatures.aliases,
    );

    const delegationFeatures = await this.display.delegationFeatures();
    this.filterByDelegator = delegationFeatures.manageOthersDelegates;
    this.subs.sink =
      this.delegateFormGroup.controls.delegator.valueChanges.subscribe(
        async (value: {
          empId: string;
          firstName: any;
          lastName: any;
          middleName: any;
          empUNum: any;
          managerUserId: any;
          encryptedEmpId: string;
        }) => {
          if (value && value.empUNum != null) {
            this.viewDelegatorLabel = value?.empUNum
              ? value.firstName + ' ' + value.lastName
              : '';
            this.filteredDelegator = {
              delegatorEmpUnum: value?.empUNum,
              delegatorFirstName: value?.firstName,
              delegatorLastName: value?.lastName,
              delegatorEmpId: value?.empId,
              delegatorHrMasterUid: value?.managerUserId,
              encryptedDelegatorEmpId: value?.encryptedEmpId,
            };
            this.filteringByDelegator = true;
            this.showPanels = true;
            await this.delegateService.loadUpdateDelegatees(value?.empUNum);

            this.updateLoading();
          } else if (!value) {
            this.viewDelegatorLabel = '';
            this.filteringByDelegator = false;
            this.showPanels = !this.delegationFeatures.manageOwnDelegates
              ? false
              : true;
            await this.delegateService.loadUpdateDelegatees('');
            this.updateLoading();
          }
        },
      );

    this.loading = 'Loading';
    if (this.delegationFeatures.manageOwnDelegates) {
      await this.delegateService.loadUpdateDelegatees('');
      this.updateLoading();
    } else {
      this.loading = 'Loaded';
    }
    this.resetFormGroup();
  }

  validateDates() {
    if (!this.validatingDates) {
      this.validatingDates = true;
      window.requestAnimationFrame(() => {
        this.formGroup.controls.startDate.updateValueAndValidity();
        this.formGroup.controls.startDate.markAllAsTouched();
        this.formGroup.controls.endDate.updateValueAndValidity();
        this.formGroup.controls.endDate.markAllAsTouched();
        this.cdr.detectChanges();
        this.validatingDates = false;
      });
    }
  }

  updateLoading() {
    this.loading =
      this.delegateService.currentDelegatees() &&
      this.delegateService.currentDelegatees().length > 0
        ? 'Loaded'
        : this.delegateService.currentDelegatees() &&
            this.delegateService.currentDelegatees().length === 0
          ? 'Empty'
          : 'Loading';
  }

  setCurrentValues(isAddNew: boolean = false) {
    this.addValidators(isAddNew);
    if (this.current) {
      if (!isAddNew && this.current.isExistingDelegatee) {
        const existingDelegate = this.delegateService
          .currentDelegatees()
          .find((d) => d.delegateeEmpUnum === this.current.delegateeEmpUnum);

        if (existingDelegate) {
          this.current = {
            ...this.current,
            dateEffective: existingDelegate.dateEffective,
            dateExpire: existingDelegate.dateExpire,
            addAbsences: existingDelegate.addAbsences,
            reportClaim: existingDelegate.reportClaim,
            emailCorrespondence: existingDelegate.emailCorrespondence,
            delegatePk: existingDelegate.delegatePk,
          };
        }
      }

      const emailsAreMissing =
        !this.current.delegateeEmail || !this.current.delegatorEmail;

      if (emailsAreMissing) {
        this.formGroup.controls.receiveEmail.disable();
      } else {
        this.formGroup.controls.receiveEmail.enable();
      }

      this.formGroup.patchValue({
        startDate: isAddNew ? '' : this.current.dateEffective,
        endDate: isAddNew ? '' : this.current.dateExpire,
        reportAbsence: this.current.addAbsences,
        reportClaim: this.current.reportClaim,
        receiveEmail: this.current.emailCorrespondence,
      });
      this.noChangesMade = false;
      if (isAddNew) {
        this.formGroup.markAsDirty();
      }
      if (!isAddNew) {
        window.requestAnimationFrame(() => {
          this.formGroup.controls.startDate.markAsTouched();
          this.formGroup.controls.startDate.updateValueAndValidity();
          this.formGroup.controls.endDate.markAsTouched();
          this.formGroup.controls.endDate.updateValueAndValidity();
        });
      }
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.ariaLabelledBy = isAddNew ? 'addDelegate' : 'editDelegate';
    this.dialogRef = this.dialog.open(this.editDialog, dialogConfig);
  }

  async removeDelegate() {
    if (this.session.isAuditorPreview) {
      this.snackbar.show(
        'Preview-only mode. Delegate not removed.',
        SnackbarType.Info,
      );
      return;
    }

    this.loading = 'Loading';
    this.current.deletedFlag = true;
    await this.delegateService.upsertDeleteDelegatee(
      this.current,
      this.filteredDelegator,
    );
    await this.delegateService.checkExpiringDelegations();

    if (this.searchResults?.length > 0) {
      const matchingSearchResult = this.searchResults.find(
        (result) => result.delegateeEmpUnum === this.current.delegateeEmpUnum,
      );

      if (matchingSearchResult) {
        matchingSearchResult.isExistingDelegatee = false;

        if (this.searchResultList) {
          this.searchResultList.updateDataSource();
        }
      }
    }
    this.updateLoading();
    srSpeak('Delegate removed', 'polite');
  }

  addValidators(isAddNew: boolean) {
    this.startControl.setValidators([Validators.required]);
    this.endControl.setValidators([Validators.required]);
  }

  resetFormGroup() {
    this.formGroup.reset({
      startDate: '',
      endDate: '',
      reportAbsence: false,
      reportClaim: false,
      receiveEmail: false,
    });
  }

  async addDelegate() {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.invalid) {
      this.noChangesMade = false;
      return Promise.resolve(false);
    }
    if (!this.formGroup.dirty) {
      this.noChangesMade = true;
      return Promise.resolve(false);
    }
    this.noChangesMade = false;
    if (this.session.isAuditorPreview) {
      const message =
        this.editLabel === 'Add delegate'
          ? 'Preview-only mode. Delegate not added.'
          : 'Preview-only mode. Delegate changes not saved.';
      this.snackbar.show(message, SnackbarType.Info);
      this.dialogRef?.close();
      return Promise.resolve(true);
    }

    this.loading = 'Loading';
    this.current.dateEffective = this.formGroup.get('startDate')?.value ?? '';
    this.current.dateExpire = this.formGroup.get('endDate')?.value ?? '';
    this.current.addAbsences =
      this.formGroup.get('reportAbsence')?.value ?? false;
    this.current.reportClaim =
      this.formGroup.get('reportClaim')?.value ?? false;
    this.current.emailCorrespondence =
      this.formGroup.get('receiveEmail')?.value ?? false;
    await this.delegateService.upsertDeleteDelegatee(
      this.current,
      this.filteredDelegator,
    );
    await this.delegateService.checkExpiringDelegations();

    if (!this.current.isExistingDelegatee) {
      if (this.searchResults?.length > 0) {
        this.searchResults = this.searchResults.filter(
          (result) => result.delegateeEmpUnum !== this.current.delegateeEmpUnum,
        );

        if (this.searchResultList) {
          this.searchResultList.updateDataSource();
        }
      }
    }

    this.resetFormGroup();
    this.loading = 'Loaded';
    this.dialogRef.close();
    srSpeak('Delegate added or edited', 'polite');
    return Promise.resolve(true);
  }

  async searchDelegatees(request: SearchRequest) {
    this.isMaxCount = false;
    this.searchLoading = 'Loading';
    const ownEmpUnum = this.filteringByDelegator
      ? this.filteredDelegator.delegatorEmpUnum
      : null;
    const delegateSearchInfo =
      await this.delegateService.getDelegateSearchResults(
        request.getParameters(),
        ownEmpUnum,
      );

    const currentDelegatees = this.delegateService.currentDelegatees();

    this.searchResults = delegateSearchInfo.delegatees.map((delegatee) => ({
      ...delegatee,
      isExistingDelegatee: currentDelegatees.some(
        (current) => current.delegateeEmpUnum === delegatee.delegateeEmpUnum,
      ),
    }));

    this.isMaxCount = delegateSearchInfo.isMaxCount;
    this.searchLoading =
      this.searchResults && this.searchResults.length > 0
        ? 'Loaded'
        : this.searchResults && this.searchResults.length === 0
          ? 'Loaded'
          : 'Empty';
  }

  _results_export() {
    const claimRows = deepCopy(this.searchResults);

    const request = new ExportRequest();
    request.fileName = 'Delegates_Search.xlsx';
    request.sheets = [
      {
        name: 'Delegates_Search',
        rows: claimRows,
        headers: [
          { label: 'NAME', value: 'delegateeLabel' },
          { label: 'MANAGER', value: 'managerLabel' },
        ],
      },
    ];
    this.export.emit(request);
    this.excel.export(request);
  }

  _export() {
    const claimRows = deepCopy(this.delegateService.currentDelegatees());

    const request = new ExportRequest();
    request.fileName = 'Delegates';

    request.sheets = [
      {
        name: 'Delegates',
        rows: claimRows,
        headers: [
          { label: 'DELEGATE', value: 'delegateeLabel' },
          {
            label: 'DELEGATION START DATE',
            value: 'dateEffective',
            format: 'date',
          },
          { label: 'DELEGATION END DATE', value: 'dateExpire', format: 'date' },
          {
            label: this.inpageAliasService.getTransformedValue(
              this.reportClaimLabel,
              'uppercase',
            ),
            value: 'reportClaim',
          },
          { label: 'REPORT AN ABSENCE', value: 'addAbsences' },
          {
            label: 'RECEIVE EMAIL CORRESPONDENCE FOR CLAIM',
            value: 'emailCorrespondence',
          },
        ],
      },
    ];

    this.export.emit(request);
    this.excel.export(request, [], '.xlsx');
  }
  dateonly(d: Date): Date {
    return new Date(d.toDateString());
  }

  validateInputs(): any {
    const dateRangeMsg =
      'Date range overlaps existing dates for this delegate.';
    const curDelRows = this.delegateService
      .currentDelegatees()
      .filter(
        (d) =>
          this.current &&
          d.delegateeEmpId === this.current.delegateeEmpId &&
          d.delegatePk !== this.current.delegatePk,
      );
    const curDelDates = curDelRows.map((cd) => {
      return {
        startDate: new Date(cd.dateEffective),
        endDate: new Date(cd.dateExpire),
      };
    });

    const yearMs = 365 * 24 * 60 * 60 * 1000;
    // only do extra validations if we don't have a basic error like required or invalid date format
    if (
      (this.startControl.errors === null && this.endControl.errors === null) ||
      (this.startControl.errors !== null &&
        !this.startControl.errors['matDatepickerParse']) ||
      (this.endControl.errors !== null &&
        !this.endControl.errors['matDatepickerParse'])
    ) {
      // check start date past end date
      if (this.startDate.getTime() > this.endDate.getTime()) {
        const dateInFutureMsg = 'Error : Enter a valid date range';
        this.startControl.setErrors({
          startInFutureStart: true,
          customMsg: dateInFutureMsg,
        });
        this.endControl.setErrors({
          startInFutureEnd: true,
          customMsg: dateInFutureMsg,
        });
        return null;
      }

      // check end date has not already past
      const yesterday = new Date();
      yesterday.setHours(0, 0, 0);
      yesterday.setDate(yesterday.getDate() - 1);
      if (this.endDate < yesterday) {
        this.endControl.setErrors({
          startInFutureEnd: true,
          customMsg: 'Error : The end date must be today or a future date.',
        });
        return null;
      }

      // check end date not greater than a year from start date
      if (this.endDate.getTime() - this.startDate.getTime() > yearMs) {
        const periodOverYearMsg =
          'Error : Access period must be less than one year.';

        this.startControl.setErrors({
          periodOverYearStart: true,
          customMsg: periodOverYearMsg,
        });
        this.endControl.setErrors({
          periodOverYearEnd: true,
          customMsg: periodOverYearMsg,
        });
        return;
      }

      let addedError = false;

      if (this.startControl.errors !== null) {
        // && startErrors == null) {
        //this.startControl.updateValueAndValidity();
      }

      if (this.endControl.errors !== null) {
        // && endErrors == null) {
        //this.endControl.updateValueAndValidity();
      }

      if (
        addedError ||
        this.startControl.errors !== null ||
        this.endControl.errors !== null
      ) {
        return null;
      }
    } else {
      return null;
    }
    if (this.startControl.errors !== null || this.endControl.errors !== null) {
      // console.log(
      //   'VALIDATING INPUTS',
      //   this.startControl.errors,
      //   this.endControl.errors
      // );
    }

    this.endControl.setErrors(null);
    this.startControl.setErrors(null);
    return null;
  }
}
